import $ from 'jquery';
import HistoryManager from '../util/HistoryManager';
import InputService from '../service/InputService';
import SelectService from '../service/SelectService';
import BlogService from '../service/BlogService';

let page = 1;

const getFilterParameters = () => {
    const parameters = HistoryManager.current().getParameters();
    const category = SelectService.getValue('blog-category');
    if (category) {
        parameters.category = category;
    }
    return parameters;
};

const blogItemsDom = $('.blog-items');

$('.blog-sidebar').submit(function (event) {
    page = 1;
    event.preventDefault();
    const parameters = getFilterParameters();
    $('.blog-more').addClass('blog-more--hidden');
    BlogService.getItems(parameters)
        .then((response) => {
            if (response.items.length === 0) {
                $('.blog-empty').removeClass('blog-empty--hidden');
            } else {
                $('.blog-empty').addClass('blog-empty--hidden');
            }
            if (response.nextpage) {
                $('.blog-more').removeClass('blog-more--hidden');
            } else {
                $('.blog-more').addClass('blog-more--hidden');
            }
            BlogService.renderItems(response.items);
        });
});

InputService.onChange('blog-search', (value) => {
    if (blogItemsDom.length === 0) {
        const category = SelectService.getValue('blog-category');
        HistoryManager.push(`/blog/${category}/?search=${value}`);
        window.location.reload();
    }
});

SelectService.onQuery('blog-category', (name, value) => {
    if (value === false) {
        HistoryManager.push(`/blog/${window.location.search}`);
    } else {
        HistoryManager.push(`/blog/${value}/${window.location.search}`);
    }

    if (blogItemsDom.length === 0) {
        window.location.reload();
    }
});


$('.blog-more').click(function () {
    page += 1;

    const parameters = getFilterParameters();
    parameters.page = page;

    BlogService.getItems(parameters)
        .then((response) => {
            if (response.items.length === 0) {
                $('.blog-empty').removeClass('blog-empty--hidden');
            } else {
                $('.blog-empty').addClass('blog-empty--hidden');
            }
            if (response.nextpage) {
                $('.blog-more').removeClass('blog-more--hidden');
            } else {
                $('.blog-more').addClass('blog-more--hidden');
            }
            BlogService.renderItems(response.items, true);
        });
});
